import React from "react";
import { Helmet } from "react-helmet-async";
import { company, site } from "../../data/siteContent";

export default function OrganizationJsonLd() {
  const siteUrl = (site.url || "https://nabhtech.com").replace(/\/$/, "");
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: company.name,
    url: siteUrl,
    logo: `${siteUrl}${company.logos.full}`,
    description: company.description,
    email: company.email,
    telephone: company.phoneTel,
    address: {
      "@type": "PostalAddress",
      streetAddress: "166, Ahilya Nagar, Scheme No 51",
      addressLocality: "Indore",
      addressRegion: "Madhya Pradesh",
      postalCode: "452006",
      addressCountry: "IN",
    },
    sameAs: [company.social.linkedin, company.social.facebook],
    areaServed: ["IN", "Worldwide"],
    knowsAbout: [
      "Web Development",
      "Mobile App Development",
      "EdTech Software",
      "Cloud Consulting",
      "UI/UX Design",
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
